import React from 'react';
import type { Highlight } from '../../types';
import HighlightLeft from './HighlightLeft';
import HighlightRight from './HighlightRight';

interface HighlightSpreadProps {
  data: Highlight;
  ariaTitle: string;
  /**
   * When the spread lives inside a deck, the deck owns the `is-active` /
   * `display:none` toggling and the 3-phase flip transform classes. Letting
   * the deck pass a className keeps the spread itself dumb — it just renders.
   */
  className?: string;
}

/**
 * The two-page caderno spread (left + right + spine + stitch). Shared by
 * the single-highlight `<Highlight />` outer and the multi-highlight
 * `<HighlightDeck />`. Does not render the outer <section> or reveal hook —
 * those belong to the surface that composes the spread.
 */
const HighlightSpread: React.FC<HighlightSpreadProps> = ({ data, ariaTitle, className }) => (
  <article
    className={`psl-hl${className ? ` ${className}` : ''}`}
    data-accent={data.accent}
    data-kind={data.kind}
  >
    <HighlightLeft data={data} />
    <div className="psl-hl-spine" aria-hidden="true" />
    <div className="psl-hl-stitch" aria-hidden="true" />
    <HighlightRight data={data} ariaTitle={ariaTitle} />
  </article>
);

export default HighlightSpread;
